<template>
  <div class="issue-check">
    <div class="main">
      <subfield>
        <template slot="list">
          <trees :title="$t('crm1')" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        </template>
        <template slot="content">
          <enfold-ucd>
            <template slot="up">
              <div class="top">
                <div class="c-u-left">
                  <!-- <el-checkbox v-model="allselect" @change="listSelectAll" v-if="this.isList==true">
                  </el-checkbox>-->
                  <el-checkbox v-model="mapAllSelect" @change="mapSelectAll" :indeterminate="isIndeterminate" v-if="this.isList == false" style="margin-right: 28px;"></el-checkbox>
                  <el-button type="primary" @click="check" size="mini" round>{{ $t("review.review") }}</el-button>
                  <el-button type="danger" @click="mulDelete" size="mini" round>{{ $t("explorer.delete")}}</el-button>
                  <!-- <i class="icon">
										<img src="@/assets/images/public/public_delete.png" @click="mulDelete"/>
                  </i>-->
                </div>
                <div class="c-u-right">
                  <div class="select">
                    <el-select v-model="select_data" @change="changeSelect" size="mini">
                      <el-option v-for="item in options" :key="item.value" :label="$t(item.label)" :value="item.value"></el-option>
                    </el-select>
                  </div>
                  <div class="search">
                    <el-input v-model="search_data" :placeholder="$t('review.enterKey')" size="mini">
                      <i slot="suffix" class="el-icon-search" @click="search"></i>
                    </el-input>
                  </div>
                  <div class="icons">
                    <i class="icon" @click="changeList">
                      <img v-if="this.isList == false" class="icon" src="@/assets/images/public/public_list_nor.png" />
                      <img v-else class="icon" src="@/assets/images/public/public_list_sel.png" />
                    </i>
                    <i class="icon" @click="changeMa">
                      <img v-if="this.isList == false" class="icon" src="@/assets/images/public/public_chart_sel.png" />
                      <img v-else class="icon" src="@/assets/images/public/public_chart_nor.png" />
                    </i>
                  </div>
                </div>
              </div>
            </template>
            <template slot="center">
              <template v-if="isList">
                <el-table :data="materialList" :row-key="getRowKey" ref="multipleTable" @row-click="selectRow" @selection-change="selectionLineChangeHandle" v-loading="tableLoading">
                  <el-table-column type="selection" :reserve-selection="true" :selectable="
                      (row) => {
                        // return row.material_state == 0;
                        return true;
                      }
                    "></el-table-column>
                  <el-table-column :label="$t('review.screenshot')" width="120">
                    <template slot-scope="scope">
                      <img :src="scope.row.ref_thumb_url" style="width: 96px; height: 54px" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" :label="$t('review.name')"></el-table-column>
                  <el-table-column prop="gn" :label="$t('review.group')"></el-table-column>
                  <el-table-column prop="create_time" :label="$t('review.createTime')"></el-table-column>
                  <el-table-column prop="user_name" :label="$t('review.publisher')">
                    <template slot-scope="scope">{{
                      `${scope.row.user_name.substring(
                        0,
                        scope.row.user_name.indexOf("&")
                      )}`
                    }}</template>
                  </el-table-column>
                  <el-table-column :label="$t('review.operate')" width="250">
                    <template slot-scope="scope">
                      <template v-if="scope.row.material_state == 0">
                        <span @click="openDetail(scope.row)" style="color: #2fb3ff; cursor: pointer">{{ $t("review.review") }}</span>
                      </template>
                      <template v-if="scope.row.material_state == 1">
                        <template v-if="scope.row.check_user != null">
                          <span style="color: red">{{
                            `${scope.row.check_user.substring(
                              0,
                              scope.row.check_user.indexOf("&")
                            )}`
                          }}</span>
                          <span>{{
                            `${scope.row.check_time.substring(
                              0,
                              scope.row.check_time.indexOf(" ")
                            )}`
                          }}</span>
                        </template>
                        <!-- <span
                        style="margin-left: 10px;">{{`${scope.row.check_time.substring(0,10)}`}}</span>-->
                        <el-popover placement="bottom" width="200" trigger="click" :content="scope.row.check_remark">
                          <span style="
                              color: #2fb3ff;
                              margin-left: 10px;
                              cursor: pointer;
                            " slot="reference">{{ $t("review.check") }}</span>
                        </el-popover>
                      </template>
                      <template v-if="scope.row.material_state == 2">
                        <template v-if="scope.row.check_user != null">
                          <span style="color: #00c48f">{{
                            `${scope.row.check_user.substring(
                              0,
                              scope.row.check_user.indexOf("&")
                            )}`
                          }}</span>
                          <span>{{
                            `${scope.row.check_time.substring(
                              0,
                              scope.row.check_time.indexOf(" ")
                            )}`
                          }}</span>
                        </template>

                        <!-- <span
                        style="margin-left: 10px;">{{`${scope.row.check_time.substring(0,10)}`}}</span>-->
                      </template>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <template v-else>
                <div class="thum">
                  <template v-if="this.materialList.length != 0">
                    <div class="items" v-for="(item, index) in this.materialList" :key="index">
                      <div class="top_img">
                        <img :src="item.ref_thumb_url" class="timg" />
                        <div class="itemselect" :class="{
                            itemselect_true: item.isChecked,
                            itemselect_block:
                              itemsDataList.length == 0 ? false : true,
                          }" @click="selectDatesByItems(item)"></div>
                        <div class="button">
                          <el-button @click="itemCheck(item)" size="small" v-show="item.material_state == 0">{{ $t("review.review") }}</el-button>
                        </div>
                      </div>
                      <div class="bottom_name">
                        <div class="name">{{ item.name }}</div>
                        <template v-if="item.material_state == 2">
                          <div class="check" style="color: #00c48f">
                            {{ $t("review.pass") }}
                          </div>
                        </template>
                        <template v-if="item.material_state == 1">
                          <div class="check" style="color: red">
                            {{ $t("review.reject") }}
                          </div>
                        </template>
                        <template v-if="item.material_state == 0">
                          <div class="check">{{ $t("review.waitReview") }}</div>
                        </template>
                      </div>
                    </div>
                    <div style="width: 180px; border: 1px solid none"></div>
                    <div style="width: 180px; border: 1px solid none"></div>
                    <div style="width: 180px; border: 1px solid none"></div>
                  </template>
                  <template v-else>
                    <div class="no-data">{{ $t("terminal.noData") }}</div>
                  </template>
                </div>
              </template>
            </template>
            <template slot="down">
              <div class="down">
                <template v-if="this.isList == true">
                  <span class="total">{{
                    `${$t("terminal.selected")}:${this.listSeletList.length}`
                  }}</span>
                  <pagination :current="current" :page="this.page" :limit="limit" @currentChange="currentChange"></pagination>
                </template>
                <template v-else>
                  <span class="total">{{
                    `${$t("terminal.selected")}:${this.itemsDataList.length}`
                  }}</span>
                  <pagination :current="current" :page="this.page" :limit="limit" @currentChange="itemCurrentChange"></pagination>
                </template>
              </div>
            </template>
          </enfold-ucd>
        </template>
      </subfield>
      <form-dialog :title="$t('review.materialCheck')" :dialogVisible="mtCheckVisible" dWidth="650px" @closeDialog="mtCheckClose">
        <div class="diamain">
          <div class="diaimg">
            <template v-if="this.current_check.type == 2">
              <img :src="this.detail_img" />
            </template>
            <template v-if="this.current_check.type == 1">
              <video :src="this.current_check.ref_url" controls="controls"></video>
            </template>
          </div>
          <div class="diainput">
            <div class="content">
              <el-input v-model="reject_data" size="small" :placeholder="$t('review.pleaseInputContent')"></el-input>
            </div>
            <div class="button">
              <!-- <div class="publish" @click="publish(2)">通过</div>
              <div class="reject" @click="publish(1)">拒绝</div>-->
              <el-button type="success" size="small" round style="margin-left: 5px" @click="publish(2)">{{ $t("review.approve") }}</el-button>
              <el-button type="danger" size="small" round @click="publish(1)">{{
                $t("review.rejectReview")
              }}</el-button>
            </div>
          </div>
        </div>
      </form-dialog>
      <form-dialog :title="$t('review.releaseReview')" :dialogVisible="allCheckVisible" @closeDialog="allCheckClose" dWidth="550px">
        <div class="all-main">
          <div class="all-input">
            <el-input v-model="all_reject" :placeholder="$t('review.resonForReject')"></el-input>
          </div>
          <div class="all-button">
            <el-button type="success" round style="margin-left: 5px" @click="allPublish(2)">{{ $t("review.approve") }}</el-button>
            <el-button type="danger" round @click="allPublish(1)">{{
              $t("review.rejectReview")
            }}</el-button>
            <!-- <div class="publish" @click="allPublish(2)">通过</div>
            <div class="reject" @click="allPublish(1)">拒绝</div>-->
          </div>
        </div>
      </form-dialog>
      <dele-dialog :title="$t('crm2')" :dialogVisible="delDialogVisible" @closeDialog="delCloseDialog">
        <div style="text-align:center;height: 60px;line-height: 60px">{{$t('crm3')}}?</div>
      </dele-dialog>
    </div>
  </div>
</template>

<script>
const issueURL = '/admin/check/checkMaterialList';
// const setURL = "/admin/check/checkMaterial";
import {
  mPagination
} from "@/components/basics/mixins";

import subfield from '@/components/basics/Subfield';
import EnfoldUcd from '@/components/basics/EnfoldUCD';
import pagination from '@/components/basics/Pagination';
import trees from '@/components/basics/Trees';
import FormDialog from '@/components/basics/FormDialog'
import DeleDialog from "@/components/basics/DelDialog"

export default {
  name: "MaterialCheck",
  components: {
    subfield,
    trees,
    EnfoldUcd,
    pagination,
    FormDialog,
    DeleDialog
  },
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      materialList: [],
      itemMaterialList: [],
      currentTableSelect: [],
      noCheckList: [],
      listSeletList: [],
      selectDatas: [],
      itemsDataList: [],
      itemsCurrentSelect: [],
      itemsNoselect: [],
      itemsNoselectList: [],
      itemsData: [],
      seleted_list: [],
      delDialogVisible: false,
      options: [{
        value: '0,1,2',
        label: 'review.all'
      }, {
        value: '0',
        label: 'review.waitReview'
      }, {
        value: '1',
        label: 'review.reject'
      }, {
        value: '2',
        label: 'review.approves'
      }],

      current: 0,

      search_data: '',
      select_data: '0,1,2',
      reject_data: '',
      detail_img: '',
      current_check: '',
      all_reject: '',

      mtCheckVisible: false,
      allCheckVisible: false,
      isList: true,
      allselect: false,
      mapAllSelect: false,
      tableLoading: false,
      isIndeterminate: false
    }
  },
  methods: {

    selectRow() {
      // this.$refs.multipleTable.clearSelection();
      // this.$refs.multipleTable.toggleRowSelection(row, true);
    },
    changeSelect(val) {
      console.log(val)
      this.getMaterial();
    },
    openDetail(row) {
      console.log(row);
      this.current_check = row;
      this.detail_img = row.ref_url;
      this.mtCheckVisible = true;
    },
    itemCheck(item) {
      this.current_check = item;
      this.detail_img = item.ref_url;
      this.mtCheckVisible = true;
    },
    changeList() {
      this.page = 1;
      this.isList = true;
      this.getMaterial();
    },
    changeMa() {
      this.page = 1;
      this.isList = false;
      this.getMaterial();
      //this.getItemDataList();
    },
    check() {
      if (this.isList) {
        if (this.listSeletList.length == 0) {
          this.$msg({ type: 'warning', message: this.$t('review.selectTips') });
          return;
        }
      } else {
        if (this.itemsDataList.length == 0) {
          this.$msg({ type: 'warning', message: this.$t('review.selectTips') });
          return;
        }
      }
      this.allCheckVisible = true;
    },
    mulDelete() {
      if (this.isList) {
        if (this.seleted_list.length === 0) {
          this.$msg({
            type: 'warning',
            message: this.$t('review.selectTips1')
          })
        } else {
          //console.log(this.seleted_list)
          this.delDialogVisible = true;
        }
      } else {
        if (this.itemsDataList.length == 0) {
          this.$msg({
            type: 'warning',
            message: this.$t('review.selectTips1')
          })
        } else {
          this.delDialogVisible = true;
        }
      }
    },
    delCloseDialog(isConfirm) {


      if (isConfirm) {
        let ids = [];
        let list = this.isList ? this.seleted_list : this.itemsDataList;

        this.$refs.multipleTable.clearSelection();
        this.itemsDataList = [];

        list.forEach(ele => {
          (ele.material_state !== 0) && ids.push(ele.id);
        });

        if (ids.length === 0) {
          this.$msg({ type: 'warning', message: this.$t('crm4') });
          return;
        }

        this.$http.post("/admin/check/checkMaterialDel", { mids: ids.toString() }, (res) => {
          this.$msg({ type: 'success', message: this.$t('crm5') });
          res > 0 && this.getMaterial();
        });
      }
      this.delDialogVisible = false;

    },
    mtCheckClose() {
      this.mtCheckVisible = false;
      this.reject_data = '';
    },
    allCheckClose() {
      this.allCheckVisible = false;
    },
    async allPublish(type) {
      if (type == 1 && this.all_reject == "") {
        this.$msg({ type: 'warning', message: this.$t('review.resonForReject') });
        return;
      }
      this.materialCheck(this.listSeletList, type, this.all_reject);

      // let ids = [];
      // let group_ids = [];
      // if (this.isList) {
      //   this.listSeletList.forEach(ele => {
      //     ids.push(ele.id);
      //     group_ids.push(ele.group_id);
      //   })
      // } else {
      //   this.itemsDataList.forEach(ele => {
      //     ids.push(ele.id);
      //     group_ids.push(ele.group_id);
      //   })
      // }
      // group_ids = Array.from(new Set(group_ids));

      // if (type == 1) {
      //   if (this.all_reject == "") {
      //     this.$msg({
      //       type: 'warning',
      //       message: this.$t('review.resonForReject')
      //     })
      //   } else {
      //     await this.$http.post(setURL, {
      //       check_result: type,
      //       mids: ids.toString(),
      //       group_ids: group_ids.toString(),
      //       remark: this.all_reject
      //     })
      //     this.allCheckVisible = false;
      //     this.itemsDataList = [];
      //     this.getMaterial();
      //   }
      // } else if (type == 2) {
      //   await this.$http.post(setURL, {
      //     check_result: type,
      //     mids: ids.toString(),
      //     group_ids: group_ids.toString(),
      //     remark: this.all_reject
      //   });
      //   this.allCheckVisible = false;
      //   this.itemsDataList = [];
      //   this.getMaterial();
      // }
    },
    search() {
      this.getMaterial();
    },
    getRowKey(row) {
      return row.id;
    },
    currentChange(val) {
      this.$refs.multipleTable.clearSelection();
      this.page = val;
      this.getMaterial();
      console.log('选择的数据....', this.listSeletList)
    },
    itemCurrentChange(val) {
      this.itemsDataList = [];
      this.mapAllSelect = false;
      this.page = val;
      this.getMaterial();
      //this.getItemDataList();
    },
    getAssets(ids) {
      this.groupIds = ids.ids;
      this.groupId = ids.id;
      this.getMaterial();
    },
    async publish(type) {
      if (type == 1 && this.reject_data == "") {
        this.$msg({ type: 'warning', message: this.$t('review.resonForReject') });
        return;
      }
      this.materialCheck([this.current_check], type, this.reject_data);

      // if (type == 1) {
      //   if (this.reject_data == "") {
      //     this.$msg({
      //       type: 'warning',
      //       message: this.$t('review.resonForReject')
      //     })
      //   } else {
      //     await this.$http.post(setURL, {
      //       check_result: type,
      //       mids: this.current_check.id,
      //       group_ids: this.current_check.group_id,
      //       remark: this.reject_data
      //     });
      //     this.getMaterial();
      //     this.mtCheckVisible = false;
      //   }

      // } else if (type == 2) {
      //   await this.$http.post(setURL, {
      //     check_result: type,
      //     mids: this.current_check.id,
      //     group_ids: this.current_check.group_id,
      //     remark: this.reject_data
      //   });
      //   this.getMaterial();
      //   this.mtCheckVisible = false;
      // }

    },
    async materialCheck(list, check_result, remark) {
      let mids = list.map((m) => m.id).join(",");
      let group_ids = Array.from(new Set(list.map((m) => m.group_id))).join(",");
      await this.$http.post("/admin/check/checkMaterial", { check_result, mids, group_ids, remark }, () => { });
      this.getMaterial();
      this.mtCheckVisible = false;
      this.allCheckVisible = false;
    },
    reject() {
      if (!this.reject_data) {
        this.$msg({
          type: 'warning',
          message: this.$t('review.resonForReject')
        })
      } else {
        console.log('原因', this.reject_data);
        this.mtCheckVisible = false;
      }
    },
    selectionLineChangeHandle(val) {
      this.seleted_list = val;
      this.currentTableSelect = val;
      this.listSeletList = val;
      console.log('选择的数据....', this.listSeletList)
    },
    listSelectAll() {
      if (this.allselect == false) {
        this.$refs.multipleTable.clearSelection();
        this.panduan = false;
      } else {
        this.materialList.forEach((ele) => {
          this.$refs.multipleTable.toggleRowSelection(ele,
            true); //这一条语句会自动触发eltable的selectionchange函数
        })
      }
    },
    mapSelectAll() { //全选所有
      if (this.mapAllSelect == true) {
        this.itemPanduan = true; //itemPanduan记录全选所有的状态，为true时候翻页时判断并将ischecked置为true
        this.materialList.forEach((ele) => {
          if (ele.isChecked == false) {
            //点击选择所有时候，把本页未选择的加入itemsDataList 数组，并把isChecked置为true
            ele.isChecked = true;
            this.itemsDataList.push(ele);
            this.itemsCurrentSelect.push(ele);
          }
        });
      } else {
        this.itemPanduan = false;
        this.materialList.forEach((ele) => {
          if (ele.isChecked == true) {
            //点击选择所有时候，
            // this.itemsDataList.splice(this.itemsDataList.indexOf(ele),
            // 	1) //把本页选择的从itemsDataList 数组删除，并把isChecked置为false
            ele.isChecked = false;
          }
        });
        this.itemsDataList = [];
        this.itemsNoselectList = [];
        this.itemsCurrentSelect = [];
      }
    },
    selectDatesByItems(item) { //单个点击的选择情况
      // console.log(item);
      item.isChecked = !item.isChecked;
      if (item.isChecked == true) {
        this.itemSelectCount += 1;
        this.itemsDataList.push(item); //保存选择的item，翻页的时候将其ischecked置为true
        this.itemsCurrentSelect.push(item); //保存本页选择的数据，用于判断全选本页的状态
      } else {
        this.itemSelectCount -= 1;
        this.itemsNoselect.push(item); //取消选择时保存
        console.log("删除...", this.itemsDataList.indexOf(item));
        for (let i = 0; i < this.itemsDataList.length; i++) {
          if (item.id == this.itemsDataList[i].id) {
            this.itemsDataList.splice(i, 1);
          }
        }
        //this.itemsDataList.splice(this.itemsDataList.indexOf(item), 1)
        this.itemsCurrentSelect.splice(this.itemsDataList.indexOf(item), 1);
      }
      if (this.itemPanduan == true) {
        //当是选择全部的模式下，需要记录取消选择的设备
        if (item.isChecked == false) {
          //为false则加入未选择的列表
          let flag = 0;
          for (let i = 0; i < this.itemsNoselectList.length; i++) {
            if (item.id == this.itemsNoselectList[i].id) {
              flag = 1;
            }
          }
          if (flag == 0) {
            this.itemsNoselectList.push(item);
          }
          console.log("itemsNoselectList", this.itemsNoselectList);
        }
        if (item.isChecked == true) {
          //为true则表示重新选择了，需要从未选择列表里面删除
          for (let i = 0; i < this.itemsNoselectList.length; i++) {
            if (this.itemsNoselectList[i].id == item.id) {
              this.itemsNoselectList.splice(i, 1);
            }
          }
          console.log("itemsNoselectList", this.itemsNoselectList);
        }
      }
      console.log(this.itemsDataList);
    },
    //
    async getItemDataList() {
      await this.$http.post(issueURL, {
        limit: this.limit,
        group_id: this.groupId,
        page: this.page
      }, data => {
        this.itemMaterialList = data.data ? data.data : [];
        this.itemMaterialList.forEach((ele) => {
          ele.isChecked = false;
        })
      })
    },
    getMaterial() {
      if (this.isList) {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
        })
      }
      this.tableLoading = true;
      this.$http.post(issueURL, {
        limit: this.limit,
        group_id: this.groupId,
        dir_id: 0,
        material_state: this.select_data,
        key_word: this.search_data,
        page: this.page
      }, data => {
        this.materialList = data.data ? data.data : [];
        this.materialList.forEach(ele => {
          ele.isChecked = false;
        })
        this.current = parseInt(data.total);
        this.tableLoading = false;
      })
    }
  },
  created() {
    this.tableLoading = true;
    this.$http.post(issueURL, {
      limit: this.limit,
      group_id: this.groupId,
      dir_id: 0,
      material_state: this.select_data,
      key_word: this.search_data,
      page: this.page
    }, data => {
      this.materialList = data.data ? data.data : [];
      this.current = parseInt(data.total);
      this.materialList.forEach((ele) => {
        ele.isChecked = false;
      })
      this.tableLoading = false;
    })
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
  },
  watch: {
    itemsDataList() {
      if (this.itemsDataList.length == this.limit) {
        this.isIndeterminate = false;
        this.mapAllSelect = true;
      } else if (this.itemsDataList.length > 0 && this.itemsDataList.length < this.limit) {
        this.isIndeterminate = true;
      } else if (this.itemsDataList.length == 0) {
        this.mapAllSelect = false;
        this.isIndeterminate = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.issue-check {
  width: 100%;
  height: 100%;

  .all-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100px;

    .all-input {
      width: 100%;
      height: 40px;
    }

    .all-button {
      width: 250px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .publish {
      width: 100px;
      height: 40px;
      cursor: pointer;
      border-style: solid;
      border-width: 1px;
      border-image-slice: 1;
      border-color: linear-gradient(
        270deg,
        #86eae7 0%,
        #4cccf0 45%,
        #11adf8 100%
      );
      border-radius: 20px;
      color: #2fb3ff;
      line-height: 40px;
      text-align: center;
    }

    .reject {
      cursor: pointer;
      width: 100px;
      height: 40px;
      border-style: solid;
      border-width: 1px;
      border-color: linear-gradient(
        270deg,
        #ff907e 0%,
        #ff7878 45%,
        #ff5f72 100%
      );
      border-image-slice: 1;
      color: #ff4949;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
    }
  }

  .main {
    width: 100%;
    height: 100%;

    .top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .c-u-left {
        // margin-left: 10px;
        // width: 130px;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        .icon {
          width: 30px;
          height: 30px;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }

      .c-u-right {
        display: flex;
        align-items: center;
        // width: 500px;
        justify-content: space-between;
        .select,
        .search {
          margin-right: 28px;
        }
        .search {
          flex-basis: 40%;
          display: flex;
          height: 100%;
          border-radius: 30px;
        }

        .icons {
          width: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .icon {
          width: 30px;
          height: 30px;
        }
      }
    }

    .thum {
      width: 98%;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      align-content: flex-start;
      position: relative;

      .no-data {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .items {
        width: 180px;
        height: 180px;
        margin-top: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .top_img {
          height: 108px;
          background-color: orange;
          position: relative;

          .button {
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            visibility: hidden;
          }

          .timg {
            width: 100%;
            height: 108px;
            // object-fit: scale-down;
          }

          .itemselect {
            position: absolute;
            width: 16px;
            height: 16px;
            display: none;
            left: 5px;
            top: 5px;
            background-color: white;
            background-image: url(~@/assets/images/public/public_select_nosel.png);
            background-size: 100%;
            background-repeat: no-repeat;
            z-index: 999;
          }

          .itemselect_block {
            display: block;
          }

          .itemselect_true {
            background-image: url(~@/assets/images/public/public_select_sel.png);
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        .top_img:hover .itemselect {
          display: block;
        }

        .top_img:hover .button {
          visibility: visible;
        }

        .bottom_name {
          height: 72px;
          display: flex;
          flex-direction: column;

          .name {
            box-sizing: border-box;
            padding-top: 3px;
            padding-left: 3px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            background-color: #eefbff;
            width: 100%;
            height: 36px;
          }

          .check {
            background-color: #eefbff;
            box-sizing: border-box;
            padding-top: 3px;
            padding-left: 3px;
            text-overflow: ellipsis;
            width: 100%;
            height: 36px;
          }
        }
      }
    }

    .down {
      width: 100%;
      height: 100%;
      position: relative;
      border-top: none;

      .total {
        position: absolute;
        top: 50%;
        transform: translate(20px, -50%);
      }
    }
  }

  .diamain {
    width: 96%;
    height: 350px;
    margin: 5px auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .diaimg {
      width: 100%;
      height: 290px;
      overflow: hidden;

      img {
        width: 624px;
        height: 290px;
      }

      video {
        object-fit: fill;
        width: 624px;
        height: 290px;
      }
    }

    .diainput {
      height: 60px;
      width: 100%;

      display: flex;
      align-items: center;

      .content {
        flex: 1;
      }

      // .button {
      // 	width: 250px;
      // 	padding-left: 20px;
      // 	display: flex;
      // 	align-items: center;
      // 	justify-content: space-between;

      // 	.publish {
      // 		width: 100px;
      // 		height: 37px;
      // 		cursor: pointer;
      // 		border-style: solid;
      // 		border-width: 1px;
      // 		border-image-slice: 1;
      // 		border-color: linear-gradient(270deg,
      // 				#86eae7 0%,
      // 				#4cccf0 45%,
      // 				#11adf8 100%);
      // 		border-radius: 20px;
      // 		color: #2fb3ff;
      // 		line-height: 37px;
      // 		text-align: center;
      // 	}

      // 	.reject {
      // 		cursor: pointer;
      // 		width: 100px;
      // 		height: 37px;
      // 		border-style: solid;
      // 		border-width: 1px;
      // 		border-color: linear-gradient(270deg,
      // 				#ff907e 0%,
      // 				#ff7878 45%,
      // 				#ff5f72 100%);
      // 		border-image-slice: 1;
      // 		color: #ff4949;
      // 		line-height: 37px;
      // 		border-radius: 20px;
      // 		text-align: center;
      // 	}
      //}
    }
  }

  .select /deep/ .el-input__inner {
    border-radius: 15px;
  }

  .search /deep/ .el-input__inner {
    border-radius: 15px;
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: #2fb3ff;
    font-size: 16px;
    right: 10px;
  }

  // .search /deep/ .el-button--default {

  // 	background-color: #edfbff;
  // 	border-left-style: none;
  // 	border-left: 0;
  // }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: #333;
    }

    th:last-child > .cell {
      text-align: center;
    }
  }
}
</style>
